import planovertarget from "./planovertarget.svg";

export default function PlanOverTargetIcon() {
  return (
    <img src={planovertarget} />
  );
}